export default __webpack_public_path__ + "static/media/Litto-3.0bf258b6.png";